import { atom } from "jotai"

export type LoginState = {
  step: 1 | 2
  phone: string
}

export const loginDialogAtom = atom<LoginState>({
  step: 1,
  phone: "",
})
